import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Typography,
} from 'material-ui';
import 'cropperjs/dist/cropper.css';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import ImageCropper from '../../../components/image/cropper';
import ImageMetaFields from './ImageMetaFields';

class ImageAddDetailsCrop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedCrop: true,
            expandedMeta: false,
        };
    }

    render() {
        const {open, handleClose, handleSubmit} = this.props;
        const {imageToCrop, classes, imageRatios, cropResult} = this.props;

        if (!imageToCrop) {
            return null;
        }

        return (
            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen
                classes={{
                    paper: classes.paper,
                }}
            >
                <DialogTitle>Image Details</DialogTitle>
                <DialogContent>
                    <br />
                    <ExpansionPanel
                        expanded={this.state.expandedCrop}
                        onChange={(event, expanded) => {
                            this.setState({
                                expandedCrop: expanded,
                            });
                        }}
                    >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={classes.heading}>
                                Crop Image ({imageRatios.crop.width}:
                                {imageRatios.crop.height})
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <ImageCropper
                                autoCropArea={0.95}
                                ratioWidth={imageRatios.crop.width}
                                ratioHeight={imageRatios.crop.height}
                                imageToCrop={imageToCrop}
                                setCropResult={this.props.setCropResult}
                                cropResult={cropResult}
                                cropBoxResizable={true}
                                index={1}
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel
                        expanded={this.state.expandedMeta}
                        onChange={(event, expanded) => {
                            this.setState({
                                expandedMeta: expanded,
                            });
                        }}
                    >
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={classes.heading}>
                                Image Meta Info
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <ImageMetaFields
                                classes={this.props.classes}
                                imageMeta={this.props.imageMeta}
                                setAltField={this.props.setAltField}
                                setTitleField={this.props.setTitleField}
                                setNameField={this.props.setNameField}
                                setLinkField={this.props.setLinkField}
                                setDescriptionField={
                                    this.props.setDescriptionField
                                }
                            />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    >
                    <Button
                        onClick={handleClose}
                        variant="raised"
                        className={classes.button}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        color="primary"
                        variant="raised"
                        className={classes.button}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ImageAddDetailsCrop;



// WEBPACK FOOTER //
// ./src/containers/staff/forms/ImageAddDetailsCrop.jsx